import React from 'react';
import { cn } from '@/shared/utils/cn';
import { SidebarMenuGroupProps } from '../../types';
import { SidebarMenuItem, SidebarDivider } from '../atoms';

/**
 * ============================================
 * SIDEBAR MENU GROUP - MOLECULE
 * ============================================
 * Agrupa items del menú bajo un título de sección opcional.
 * Combina SidebarDivider y SidebarMenuItem.
 */
export const SidebarMenuGroup: React.FC<SidebarMenuGroupProps> = ({ title, items, className }) => {
  return (
    <div className={cn('ui-flex ui-w-full ui-flex-col ui-gap-16', className)}>
      {/* Título de sección con divider */}
      {title && <SidebarDivider withText text={title} />}

      {/* Lista de items */}
      <div className="ui-flex ui-w-full ui-flex-col ui-gap-4">
        {items.map((item) => (
          <SidebarMenuItem key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};
